import Hero from "../components/Hero";
import HoursLocation from "../components/HoursLocation";
import UpcommingEvents from "../components/events/UpcomingEvents";
import Reviews from "../components/reviews/Reviews";
import Welcome from "../components/Welcome";
import { Link } from "react-router-dom";
import SectionTitle from "../components/SectionTitle";
import AnimatedRentalSection from "../components/AnimatedRentalSection";

export default function Home() {
  return (
    <div>
      <Hero />
      <HoursLocation />
      <AnimatedRentalSection />
      <UpcommingEvents />
      <Reviews />
      <Welcome />
    </div>
  );
}
